import { memo } from "react";
import styled from "styled-components";
import RemainingTime from "../RemainingTime/RemainingTime";

const StyledButton = styled.button`
  font-family: "CPN" !important;
  background: ${({ $color, theme }) => $color || theme?.color?.primary};
  border-radius: 4px;
  border: none;
  color: ${({ theme }) => theme?.color?.whiteBase};
  cursor: pointer;
  font-size: 20px;
  font-weight: 700;
  height: ${({ $height }) => $height || "47.58px"};
  margin-top: ${({ $marginTop }) => $marginTop};
  text-align: center;
  transition: filter 0.5s ease;
  width: 300px;
  &:hover {
    filter: brightness(110%) hue-rotate(10deg);
  }
`;
const StyledRobinsonInfoSection = styled.div`
  row-gap: 10px;
  text-align: center;
  place-content: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 37px;
  @media (max-width: ${({ theme }) => theme?.mediaScreen?.desktop}) {
    margin-bottom: 26px;
  }
`;

const StyledTitle = styled.div`
  color: ${({ $color, theme }) => $color || theme?.color?.primary};
  font-size: 44px;
  font-weight: bold;
`;

const StyledRobinsonText = styled.span`
  color: ${({ theme }) => theme?.color?.primary};
  font-weight: bold;
`;

const StyledSecondaryText = styled.p`
  font-size: 24px;
  font-weight: normal;
`;

const StyledInfo = styled.div`
  display: block !important;
  margin: auto;
  max-width: 400px;
  margin-top: 20px;
  min-height: 84px;
  @media (max-width: ${({ theme }) => theme?.mediaScreen?.desktop}) {
    padding: 0 10px;
  }
`;
const StyledRedirectInfoText = styled.div`
  font-size: 14px;
  font-weight: normal;
  margin-top: 10px;
  text-align: center;
`;
const StyledInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 50%;
  flex-grow: 0;
  flex-shrink: 0;
`;

const StyledMobileNavigationSection = styled.div`
  margin: 10px 0;
`;
const InfoSection = memo(
  ({ handleRedirect, isMobile, isRedirected, shouldAnimate, translate }) => {
    return (
      <StyledInfoWrapper $animate={shouldAnimate}>
        <StyledRobinsonInfoSection>
          <StyledTitle>ROBINSON</StyledTitle>
          <StyledSecondaryText>{translate("joined")}</StyledSecondaryText>
          <StyledTitle $color="black">CENTRAL APP</StyledTitle>
          <div>
            <img src="/images/mobile-app-icon.svg" alt="Central App" />
          </div>
          <StyledInfo>
            <StyledSecondaryText>
              {translate("shopAllYour")}
            </StyledSecondaryText>
            <StyledSecondaryText>
              {translate("favorite")}&nbsp;
              <StyledRobinsonText>{translate("robinson")}</StyledRobinsonText>
              <span
                dangerouslySetInnerHTML={{ __html: translate("onCentral") }}
              />
            </StyledSecondaryText>
            <StyledSecondaryText>{translate("onCentral2")}</StyledSecondaryText>
          </StyledInfo>
        </StyledRobinsonInfoSection>
        {isMobile ? (
          <StyledMobileNavigationSection>
            <StyledButton
              $height="60px"
              $marginTop="7px"
              onClick={() => handleRedirect(true)}
            >
              {translate("continueOnWeb")}
            </StyledButton>
            <StyledRedirectInfoText>
              <RemainingTime
                translate={translate}
                handleRedirect={handleRedirect}
                isRedirected={isRedirected}
              />
            </StyledRedirectInfoText>
            <StyledButton
              $color="black"
              $height="60px"
              $marginTop="20px"
              onClick={() => handleRedirect()}
            >
              {translate("goToApp")}
            </StyledButton>
          </StyledMobileNavigationSection>
        ) : (
          <>
            <StyledButton $marginTop="7px" onClick={() => handleRedirect(true)}>
              {translate("shopNow")}
            </StyledButton>
            <StyledRedirectInfoText>
              <RemainingTime
                translate={translate}
                handleRedirect={handleRedirect}
                isRedirected={isRedirected}
              />
            </StyledRedirectInfoText>
          </>
        )}
      </StyledInfoWrapper>
    );
  }
);

export default InfoSection;
